module.exports = __webpack_public_path__ + "static/media/bulldozer_purple.719bc47c.svg";